import React from 'react';
import SearchPage from './SearchPage';

const BasicSearchPage = () => {
	return <SearchPage formInit="basic" />;
};

export default BasicSearchPage;
